"use strict";
// Copyright (c) 2024 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const ffi = __importStar(require("./ffi/ecash_lib_wasm_browser.js"));
const ecash_lib_wasm_bg_browser_js_1 = require("./ffi/ecash_lib_wasm_bg_browser.js");
const ecc_js_1 = require("./ecc.js");
const hash_js_1 = require("./hash.js");
const publicKeyCrypto_js_1 = require("./publicKeyCrypto.js");
/**
 * Initialize WASM from an embedded base64 payload at import time.
 *
 * Works in Node.js, browsers, and bundlers (e.g. Next.js) without a separate
 * `.wasm` file or `fs.readFileSync` at import time.
 */
const wasmRaw = Uint8Array.from(atob(ecash_lib_wasm_bg_browser_js_1.ECASH_LIB_WASM_BASE64), c => c.charCodeAt(0));
ffi.initSync(wasmRaw);
(0, ecc_js_1.__setEcc)(new ffi.Ecc());
(0, hash_js_1.__setHashes)({
    sha256: ffi.sha256,
    sha256d: ffi.sha256d,
    shaRmd160: ffi.shaRmd160,
    sha512: ffi.sha512,
    Sha256H: ffi.Sha256H,
    Sha512H: ffi.Sha512H,
});
(0, publicKeyCrypto_js_1.__setPkc)({
    algoSupported: ffi.publicKeyCryptoAlgoSupported,
    verify: ffi.publicKeyCryptoVerify,
});
//# sourceMappingURL=initWasm.js.map